import HelperAdobeEvent from "./HelperAdobeEvent";

/**
 * common file for cartCheckout steps
 * author: Ramya Kannan
 */
export function stepEventMaker(CART_DATA, quoteDetails, stepType, quoteNumber) {
  const quoteHeader = JSON.parse(sessionStorage.getItem("quoteHeader"));
  let cartData;
  let QUOTE_PRODUCT = [];
  let quoteList = [];
  let isQuoteValue = Object.entries(quoteDetails).length ? true : false;
  if (isQuoteValue) {
    let records = quoteDetails[quoteHeader?.quoteNumber]?.records;
    Object.entries(records).map((data, i) => {
      quoteList.push(data[1]);
      QUOTE_PRODUCT.push(data[1]?.product);
    });
    QUOTE_PRODUCT.map((data, ind) => {
      let copyObj = { ...data };
      let inventoryVal = copyObj?.assets?.inventory;
      copyObj.qas = inventoryVal?.qas;
      copyObj.subtotal = quoteList[ind]?.subTotal_quantity_1;
      copyObj.unitPrice = quoteList[ind]?.price_quantity_1;
      copyObj.Quantity = quoteList[ind]?.quantity_0;
      // copyObj.priceSource = getPricing(
      //   data.ERPMFRPartNumber || data.erpMfrPartNumber,
      //   data.ERPPartNumber,
      //   data.ERPPartNumberModified
      // )[0]?.priceSource;
      copyObj.quoteID = quoteList[ind]?.quoteNumber;
      copyObj.quoteType = "online";
      QUOTE_PRODUCT[ind] = copyObj;
    });
    cartData = {
      quoteID: quoteList[0]?.quoteNumber,
      quoteType: "online",
      cartType: "Quote",
    };
  }

  let prodDetails;
  if (quoteNumber) {
    prodDetails = QUOTE_PRODUCT;
  } else {
    prodDetails = CART_DATA;
  }
  if (CART_DATA?.length) {
    cartData = {
      cartType: "Checkout",
    };
  }

  HelperAdobeEvent.trackingAdobeEvent({ prodDetails, stepType, cartData });
}
